import React, { FC, useEffect } from "react";
import { PlusIcon, XCircleIcon } from "@heroicons/react/24/solid";
import Label from "components/Label/Label";
import { DAY_LIST } from "contains/contants";
import dayjs from "dayjs";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import "dayjs/locale/fr";
import { SelectHours } from "components/SelectHours";
dayjs.locale("fr");

export interface ShiftFormProps {
	className?: string;
	shift?: any;
	setShift?: any;
	errors?: any;
}

// const SelectHours: FC<any> = (props) => {
// 	let tmpDate = dayjs().set("hour", 6).set("minutes", 0);

// 	const options = [];

// 	while (tmpDate.get("hours") < 21) {
// 		options.push(tmpDate.format("HH:mm"));
// 		tmpDate = tmpDate.add(30, "minutes");
// 	}

// 	return (
// 		<Select {...props}>
// 			<option value=""></option>
// 			{options.map((o: string, index: number) => (
// 				<option value={o} key={index}>
// 					{o}
// 				</option>
// 			))}
// 		</Select>
// 	);
// };

const ShiftForm: FC<ShiftFormProps> = ({ shift, setShift, errors }) => {
	useEffect(() => {
		if (!shift.id) {
			const schedule = DAY_LIST.map((d: string) => {
				return {
					day: d,
					timeSlots: [],
				};
			});

			setShift({ ...shift, schedule });
		}
	}, [shift.id]);

	return (
		<div className="flex flex-col md:flex-row">
			<div className="flex-grow mt-10 md:mt-0 space-y-6">
				<div className="flex flex-col md:flex-row gap-5">
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Nom du Shift</Label>
						<Input
							className={
								"mt-1.5 rounded-md" +
								(errors["name"] !== undefined ? " border-danger" : "")
							}
							value={shift.name}
							onChange={({ target }) =>
								setShift({ ...shift, name: target.value })
							}
						/>
					</div>
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Couleur</Label>
						<Input
							type="color"
							className={
								"w-[50px] h-[40px] !p-2 mt-1.5 border-[1px] rounded-md" +
								(errors["color"] !== undefined ? " border-danger" : "")
							}
							value={shift.color}
							onChange={({ target }) =>
								setShift({ ...shift, color: target.value })
							}
						/>
					</div>
				</div>

				<div className="max-w-2xl flex flex-row gap-3">
					<h2 className="text-md font-semibold">Détails du shift</h2>
				</div>
				<hr className="!mt-2 border-slate-200 dark:border-slate-700"></hr>

				<div className="flex flex-col gap-5">
					{!!shift.schedule &&
						shift.schedule.map((currentSchedule: any, indexS: number) => {
							return (
								<div key={indexS}>
									<div className="flex flex-row items-center">
										<div className="w-[30%]">{currentSchedule.day}</div>
										<div>
											{currentSchedule.timeSlots.map(
												(t: any, indexT: number) => {
													return (
														<div
															className="flex flex-row items-center gap-1"
															key={indexT}
														>
															<SelectHours
																className={""}
																value={t.fromHour}
																onChange={({ target }: { target: any }) => {
																	console.log(target);
																	shift.schedule[indexS].timeSlots[
																		indexT
																	].fromHour = target.value;
																	setShift({ ...shift });
																}}
															></SelectHours>{" "}
															-
															<SelectHours
																className={""}
																value={t.toHour}
																onChange={({ target }: { target: any }) => {
																	shift.schedule[indexS].timeSlots[
																		indexT
																	].toHour = target.value;
																	setShift({ ...shift });
																}}
															></SelectHours>
															<XCircleIcon
																className="w-20 h-14 mr-0 cursor-pointer"
																aria-hidden="true"
																onClick={() => {
																	shift.schedule[indexS].timeSlots.splice(
																		indexT,
																		1
																	);
																	setShift({ ...shift });
																}}
															/>
														</div>
													);
												}
											)}
											<ButtonSecondary
												onClick={() => {
													shift.schedule[indexS].timeSlots.push({
														fromHour: "",
														toHour: "",
													});
													setShift({ ...shift });
												}}
												className="!bg-slate-100 hover:!bg-slate-200 mt-3 !py-2 !px-3 !rounded-[10px]"
											>
												<PlusIcon className="w-4 h-4 mr-0" aria-hidden="true" />
												Ajouter
											</ButtonSecondary>
										</div>
									</div>
									<hr className="!mt-2 border-slate-200 dark:border-slate-700"></hr>
								</div>
							);
						})}
					<div></div>
				</div>

				{/* <div className="mt-10 md:mt-0 space-y-1 flex-1">
					<Label>Actif / Inactif</Label>

					<Select
						className="mt-1.5"
						value={shift.enabled}
						onChange={({ target }) =>
							setShift({ ...shift, enabled: target.value })
						}
					>
						<option></option>
						<option value="true">Actif</option>
						<option value="false">Inactif</option>
					</Select>
				</div> */}
			</div>
		</div>
	);
};

export default ShiftForm;
